import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "base-modal__wrap"
}


import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AsideModal',
  props: {
  isShow: {
    type: Boolean,
    default: false,
  },
  isWhite: {
    type: Boolean,
    default: false,
  },
  fullHeight: {
    type: Boolean,
    default: false,
  },
  isHideClose: {
    type: Boolean,
    default: false,
  },
  closeOutSide: {
    type: Boolean,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const handleClose = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  return (props.isShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseFigureForIcon, {
          icon: "close",
          color: "white",
          "--is-button": "",
          class: _normalizeClass(["base-modal__close", {
        'base-modal--hide': __props.isHideClose,
        'base-modal--outside': __props.closeOutSide,
      }]),
          onClick: handleClose
        }, null, 8, ["class"]),
        _createElementVNode("div", {
          class: _normalizeClass(["base-modal", {
        'base-modal--white': __props.isWhite,
        'base-modal--fullheight': __props.fullHeight,
      }])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})